// extracted by mini-css-extract-plugin
module.exports = {"container":"AtDots_container__83zJ_","rightDot":"AtDots_rightDot__3FSMX","leftDot":"AtDots_leftDot__3OHQA"};